import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex } from '@chakra-ui/react';

import RequirementTemplateBlueprintType from '../../../../types/RequirementTemplateBlueprintType';
import LoadingSpinner from '../../../Spinner';

import RequirementTemplateBlocks from './components/RequirementTemplateBlocks';
import TemplateBuilderListRequirementsBoxHeader from './components/TemplateBuilderListRequirementsBoxHeader';

function TemplateBuilderListRequirementsBox({ blueprint }) {
  const currentTemplate = useSelector(blueprint.selectCurrentRequirementTemplate);
  const contentHeight = useSelector(blueprint.selectBuilderHeight);

  if (currentTemplate) {
    return (
      <Flex direction="column" height={contentHeight} justifyContent="center" ml={6} mr={6} width="100%">
        <TemplateBuilderListRequirementsBoxHeader blueprint={blueprint} />
        <RequirementTemplateBlocks blueprint={blueprint} />
      </Flex>
    );
  }

  return (
    <Flex direction="column" justifyContent="center" ml={6} mr={6} width="100%">
      <Box
        h="100%"
        justifyContent="center"
        layerStyle="partialPanelBottom"
        minH="74vh"
        minW="552px"
        mr={4}
        mt={1.5}
        p={6}
      >
        <LoadingSpinner />
      </Box>
    </Flex>
  );
}

TemplateBuilderListRequirementsBox.propTypes = {
  blueprint: RequirementTemplateBlueprintType
};

export default TemplateBuilderListRequirementsBox;
